<mat-expansion-panel
  class="structure-card mb-2"
  [expanded]="expanded"
  (opened)="expanded = true"
  (closed)="expanded = false"
  [style.--card-border-color]="getRoofScoreColor(structure.roof_condition?.value)">

  <mat-expansion-panel-header class="pe-0">
    <mat-panel-title>
      {{ structure.primaryStructure ? "Primary Structure (#1)" : "Structure #" + index }}
    </mat-panel-title>
    <mat-panel-description (click)="$event.stopPropagation()">
      <button mat-icon-button [matMenuTriggerFor]="outerMenu" aria-label="Actions">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu panelClass="actions-menu" #outerMenu>
        <button mat-menu-item (click)="onZoomClick(structure.footPrint.wkt, 100)">
          <mat-icon svgIcon="send"></mat-icon>
          <span>Zoom to Structure</span>
        </button>
      </mat-menu>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <!-- ── Roof Info (nested expansion) ───────────────────── -->
  <mat-expansion-panel [expanded]="expanded">
    <mat-expansion-panel-header class="pe-0">
        <mat-panel-title>Roof Info</mat-panel-title>
            <mat-panel-description (click)="$event.stopPropagation()">
              <button mat-icon-button [matMenuTriggerFor]="roofMenu" aria-label="Actions">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu panelClass="actions-menu" #roofMenu>
                <button mat-menu-item (click)="copyToClipboard(structure.roof_top_location.wkt)">
                  <mat-icon>content_copy</mat-icon>
                  <span>Copy Rooftop Point</span>
                </button>
                <button mat-menu-item (click)="onZoomClick(structure.footPrint.wkt, 75)">
                  <mat-icon svgIcon="send"></mat-icon>
                  <span>Zoom to Structure</span>
                </button>
              </mat-menu>
            </mat-panel-description>
    </mat-expansion-panel-header>
      <!-- ── Roof Score ──────────────────────────────────────── -->
      <mat-card class="roof-score-card mb-2" [style.--score-color]="getRoofScoreColor(structure.roof_condition?.value)">
          <mat-card-content class="score-grid px-2 py-1">
              <!-- Left: Score badge -->
              <div class="score-badge rounded px-2 py-1 text-center text-white align-self-center">
                  <div class="fw-bold fs-5">{{ structure.roof_condition?.value ?? "-" }}</div>
                  <div class="small">{{ getRoofScoreLabel(structure.roof_condition?.value) }}</div>
              </div>

              <!-- Center: Material, Shape, Missing Material -->
              <div class="d-flex flex-column lh-sm" style="font-size:0.7rem;">
                  <div class="d-flex justify-content-between">
                      <span class="text-muted text-nowrap">Material</span>
                      <span class="text-end text-capitalize text-black">{{ structure.roof_material?.class ?? "-" }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                      <span class="text-muted text-nowrap">Shape</span>
                      <span class="text-end text-capitalize text-black">{{ structure.roof_shape?.value ?? "-" }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                      <span class="text-muted text-nowrap">Miss. mat.</span>
                      <span class="text-end text-capitalize text-black">
                            {{ structure.roof_condition_report?.["Missing Material"]?.percentage != null
                          ? structure.roof_condition_report["Missing Material"].percentage + "%"
                          : "None" }}
                        </span>
                  </div>
              </div>

              <!-- Right: Debris, Discoloration, Tarp -->
              <div class="d-flex flex-column lh-sm ps-1" style="font-size:0.7rem;">
                  <div class="d-flex justify-content-between">
                      <span class="text-muted text-nowrap">Debris</span>
                      <span class="text-end text-capitalize text-black">
                        {{ structure.roof_condition_report?.debris?.percentage != null
                          ? structure.roof_condition_report.debris.percentage + "%"
                          : "No" }}
                        </span>
                  </div>
                  <div class="d-flex justify-content-between">
                      <span class="text-muted text-nowrap">Discol.</span>
                      <span class="text-end text-capitalize text-black">
                        {{ structure.roof_condition_report?.discolorated?.percentage != null
                          ? "Yes"
                          : "No" }}
                        </span>
                  </div>
                  <div class="d-flex justify-content-between">
                      <span class="text-muted text-nowrap">Tarp</span>
                      <span class="text-end text-capitalize text-black">
                        {{ structure.roof_condition_report?.Tarp?.percentage != null
                          ? structure.roof_condition_report.Tarp.percentage + "%"
                          : "None" }}
                        </span>
                  </div>
              </div>

          </mat-card-content>
      </mat-card>

    <!-- Discoloration chips -->
    @if (structure.roof_condition_report?.discolorated?.detected && structure.roof_condition_report?.discolorated?.types) {
      <div class="d-flex justify-content-between align-items-center pt-1">
        <span class="small text-muted fw-semibold">Discoloration</span>
        <button mat-button class="mat-button-slim hide-button" (click)="showAllDiscoloration = !showAllDiscoloration" type="button">
          {{ showAllDiscoloration ? "Hide undetected features" : "Show undetected features" }}
        </button>
      </div>
      <mat-chip-set>
        @for (chip of getDiscolorationChips(structure.roof_condition_report.discolorated.types); track chip.label) {
          <mat-chip class="my-0" [class.chip-empty]="!chip.detected">
            {{ chip.label }} ({{ chip.detail ?? "0%" }})
          </mat-chip>
        }
      </mat-chip-set>
    }

    <!-- Roof element chips -->
    @let roofElementChips = getRoofElementChips(structure.roof_elements, structure.roof_solar);
    <div class="d-flex justify-content-between align-items-center pt-1">
      <span class="small text-muted fw-semibold">Roof Features</span>
        <button mat-button class="mat-button-slim hide-button" (click)="showAllRoofFeatures = !showAllRoofFeatures" type="button">
            {{ showAllRoofFeatures ? "Hide undetected features" : "Show undetected features" }}
        </button>
    </div>
      @if (!showAllRoofFeatures && roofElementChips.length === 0) {
          <div class="no-properties-message" style="font-size: 0.6rem;">No features were detected for this roof</div>
      }
    <mat-chip-set>
      @for (chip of roofElementChips; track chip.label + (chip.type ?? '')) {
          <mat-chip class="my-0" [class.chip-empty]="!chip.detected">
          {{ chip.label }}
          @if (chip.type) {
            ({{ chip.type }}) @if(chip.area) {<span>({{ formatArea(chip.area) }})</span>} @else {<span>(0)</span>}
          } @else if (chip.count != null) {
            ({{ chip.count }})
          }
        </mat-chip>
      }
    </mat-chip-set>

  </mat-expansion-panel>

  <!-- ── Structure Info ──────────────────────────────────── -->
  <mat-expansion-panel class="mt-1" [expanded]="expanded">
      <mat-expansion-panel-header class="pe-0">
          <mat-panel-title>Structure Info</mat-panel-title>
              <mat-panel-description (click)="$event.stopPropagation()">
                <button mat-icon-button [matMenuTriggerFor]="structureMenu" aria-label="Actions">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu panelClass="actions-menu" #structureMenu>
                  <button mat-menu-item (click)="copyToClipboard(structure.footPrint.wkt)">
                    <mat-icon>content_copy</mat-icon>
                    <span>Copy Footprint</span>
                  </button>
                  <button mat-menu-item (click)="onZoomClick(structure.footPrint.wkt, 100)">
                    <mat-icon svgIcon="send"></mat-icon>
                    <span>Zoom to Structure</span>
                  </button>
                </mat-menu>
              </mat-panel-description>
      </mat-expansion-panel-header>
            @if (structure.structure_info?.building_type) {
              <div class="d-flex justify-content-between align-items-center small">
                <span class="text-muted">Building Type</span>
                <span class="text-truncate">{{ formatBuildingType(structure.structure_info?.building_type) }}</span>
              </div>
            }
            @if (structure.footPrint?.area != null) {
              <div class="d-flex justify-content-between align-items-center small">
                <span class="text-muted">Footprint area</span>
                @if(structure.footPrint?.area) {<span>{{ formatArea(structure.footPrint?.area) }}</span>} @else {<span>–</span>}
              </div>
            }
            @if (structure.structure_info?.maximum_roof_height != null) {
              <div class="d-flex justify-content-between align-items-center small">
                  <span class="text-muted">Max roof height</span>
                  <span>{{ formatLength(structure.structure_info?.maximum_roof_height) }}</span>
              </div>
            }
            @if (structure.structure_info?.entrance_elevation != null) {
              <div class="d-flex justify-content-between align-items-cente small">
                <span class="text-muted">Entrance elevation</span>
                <span>{{ formatLength(structure.structure_info?.entrance_elevation) }}</span>
              </div>
            }
            @if (structure.structure_info?.maximum_roof_heigth != null) {
              <div class="d-flex justify-content-between align-items-center small">
                <span class="text-muted">Max roof height</span>
                <span>{{ formatLength(structure.structure_info?.maximum_roof_heigth) }}</span>
              </div>
            }
            @if (structure.structure_info?.eave_height != null) {
              <div class="d-flex justify-content-between align-items-center small">
                <span class="text-muted">Eave height</span>
                <span>{{ formatLength(structure.structure_info?.eave_height) }}</span>
              </div>
            }
            @if (structure.structure_info?.volume_below_eave != null) {
              <div class="d-flex justify-content-between align-items-center small">
                <span class="text-muted">Volume (below eave)</span>
                @if(structure.structure_info?.volume_below_eave) {<span>{{ formatVolume(structure.structure_info?.volume_below_eave) }}</span>} @else {<span>–</span>}
              </div>
            }
            @if (structure.structure_info?.number_of_stories_below_eave != null) {
              <div class="d-flex justify-content-between align-items-center small">
                <span class="text-muted">Est. # of stories</span>
                <span>{{ structure.structure_info?.number_of_stories_below_eave ?? 0 }}</span>
              </div>
            }
      <div class="d-flex justify-content-between align-items-center small">
          <span class="text-muted">Building Tree Cover</span>
          <div class="bar-row">
              <mat-progress-bar
                      class="bar-percent"
                      mode="determinate"
                      [value]="structure.structure_info?.tree_cover">
              </mat-progress-bar>
              <span class="bar-percent-label">{{ structure.structure_info?.tree_cover ?? 0 }}%</span>
          </div>
      </div>
      <!-- Structure element chips -->
      @let structureChips = getStructureFeatures(structure.structure_features);
      <div class="d-flex justify-content-between align-items-center pt-1">
          <span class="small text-muted fw-semibold">Structure Features</span>
          <button mat-button class="mat-button-slim hide-button" (click)="showAllStructureFeatures = !showAllStructureFeatures" type="button">
              {{ showAllStructureFeatures ? "Hide undetected features" : "Show undetected features" }}
          </button>
      </div>
      @if (!showAllStructureFeatures && structureChips.length === 0) {
          <div class="no-properties-message" style="font-size: 0.6rem;">No features were detected for this structure</div>
      }
      <mat-chip-set>
          @for (chip of structureChips; track chip.label + (chip.type ?? '')) {
              <mat-chip class="my-0" [class.chip-empty]="!chip.detected">
                  {{ chip.label }}
              </mat-chip>
          }
      </mat-chip-set>
  </mat-expansion-panel>
    <!-- ── Defensible Space ────────────────────────────────── -->
  <mat-expansion-panel class="mt-1" [expanded]="expanded">
      <mat-expansion-panel-header class="pe-0">
          <mat-panel-title>Defensible Space</mat-panel-title>
          <mat-panel-description (click)="$event.stopPropagation()">
            <button mat-icon-button [matMenuTriggerFor]="defSpaceMenu" aria-label="Actions">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu panelClass="actions-menu" #defSpaceMenu>
              <button mat-menu-item (click)="onZoomClick(parcelWkt, 100)">
                <mat-icon svgIcon="send"></mat-icon>
                <span>Zoom to Parcel</span>
              </button>
            </mat-menu>
          </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-table [dataSource]="getDefensibleSpaceBands(structure.defensible_space?.report)" class="w-100">

          <!-- Distance column -->
          <ng-container matColumnDef="label">
              <mat-header-cell *matHeaderCellDef class="small text-muted ">Distance</mat-header-cell>
              <mat-cell *matCellDef="let band" class="small px-1 py-0">{{ band.label }}</mat-cell>
          </ng-container>

          <!-- Tree Coverage column -->
          <ng-container matColumnDef="treeCoverage">
              <mat-header-cell *matHeaderCellDef class="small text-muted">Tree Coverage</mat-header-cell>
              <mat-cell class="px-1 py-0" *matCellDef="let band">
                  @if (band.t != null) {
                      <div class="bar-row">
                          <mat-progress-bar
                              class="bar-percent"
                              mode="determinate"
                              [value]="band.t"
                              [style.--bar-color]="getDsColor(band.t)">
                          </mat-progress-bar>
                          <span class="bar-percent-label">{{ band.t | number: "1.0-0" }}%</span>
                      </div>
                  } @else {
                      <span class="small text-muted">-</span>
                  }
              </mat-cell>
          </ng-container>

          <!-- Other Structures column -->
          <ng-container matColumnDef="otherStructures">
              <mat-header-cell *matHeaderCellDef class="small text-muted">Other Structures</mat-header-cell>
              <mat-cell class="px-1 py-0" *matCellDef="let band">
                  @if (band.b != null) {
                      <div class="bar-row">
                          <mat-progress-bar
                              class="bar-percent"
                              mode="determinate"
                              [value]="band.b"
                              [style.--bar-color]="getDsColor(band.b)">
                          </mat-progress-bar>
                          <span class="bar-percent-label">{{ band.b | number: "1.0-0" }}%</span>
                      </div>
                  } @else {
                      <span class="small text-muted">-</span>
                  }
              </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="['label', 'treeCoverage', 'otherStructures']"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['label', 'treeCoverage', 'otherStructures']"></mat-row>

      </mat-table>
  </mat-expansion-panel>

</mat-expansion-panel>

